import { useTranslation } from "react-i18next";
import { formatMinorUnits } from "../../../../../../../logic/helpers/currencyAmount";
import type { SpinTogetherBenefitSummary } from "../../../../../../../logic/helpers/spinTogetherBenefits";
import "./SpinTogetherBenefits.scss";

interface SpinTogetherBenefitsProps {
    benefits: SpinTogetherBenefitSummary;
    locale: string;
}

function formatBasisPoints(basisPoints: number, locale: string): string {
    return new Intl.NumberFormat(locale, {
        style: "percent",
        maximumFractionDigits: 2,
    }).format(basisPoints / 10_000);
}

function formatCutoff(endsAt: string, locale: string): string {
    return new Intl.DateTimeFormat(locale, {
        hour: "2-digit",
        minute: "2-digit",
    }).format(new Date(endsAt));
}

export function SpinTogetherBenefits({
    benefits,
    locale,
}: SpinTogetherBenefitsProps) {
    const { t } = useTranslation();

    return (
        <section
            className="spin-together-benefits"
            aria-label={t("spinTogether.benefits.title")}
        >
            <h3 className="spin-together-benefits__title">
                {t("spinTogether.benefits.title")}
            </h3>
            <ul className="spin-together-benefits__list">
                {benefits.energy && (
                    <li className="spin-together-benefits__item">
                        {benefits.energy.amount === null
                            ? t("spinTogether.benefits.energyUnlocked")
                            : t("spinTogether.benefits.energyReceived", {
                                  amount: formatMinorUnits(
                                      benefits.energy.amount,
                                      0,
                                      locale,
                                  ),
                              })}
                    </li>
                )}
                {benefits.winBoost && (
                    <li className="spin-together-benefits__item">
                        {benefits.winBoost.basisPoints === null
                            ? t("spinTogether.benefits.winBoostActiveGeneric", {
                                  time: formatCutoff(
                                      benefits.winBoost.endsAt,
                                      locale,
                                  ),
                              })
                            : t("spinTogether.benefits.winBoostActive", {
                                  percentage: formatBasisPoints(
                                      benefits.winBoost.basisPoints,
                                      locale,
                                  ),
                                  time: formatCutoff(
                                      benefits.winBoost.endsAt,
                                      locale,
                                  ),
                              })}
                    </li>
                )}
            </ul>
        </section>
    );
}
